import { createFileRoute } from "@tanstack/react-router";
import { PosFigmaLP } from "@/components/posfigma/PosFigmaLP";
import profAnamaria from "@/assets/orto/prof-anamaria.jpg.asset.json";

const TITLE = "Pós em Fisioterapia em Gerontologia | Versão A | FEO";
const DESC =
  "Versão A da LP: pós-graduação 100% online em Fisioterapia em Gerontologia. 14 módulos, 360h, reconhecida pelo MEC. Avalie, trate e cuide do idoso com segurança e evidência.";
const URL = "https://fisioemortopedia.com.br/geronto1";

export const Route = createFileRoute("/geronto1")({
  head: () => ({
    meta: [
      { title: TITLE },
      { name: "description", content: DESC },
      { property: "og:title", content: TITLE },
      { property: "og:description", content: DESC },
      { property: "og:url", content: URL },
      { property: "og:type", content: "website" },
      { name: "robots", content: "noindex" }, // LP B em teste
    ],
    links: [{ rel: "canonical", href: URL }],
  }),
  component: GerontoLP1,
});

function GerontoLP1() {
  return (
    <PosFigmaLP
      product="geronto"
      heroBadge="Pós-Graduação 100% online"
      heroTitle={["Fisioterapia", "em Gerontologia", "que entrega resultado"]}
      heroSubtitle="Atenda o idoso com segurança, raciocínio clínico apurado e protocolos atualizados, da prevenção à reabilitação funcional."
      coordenadorNome="Anamaria Siriani"
      coordenadorFoto={profAnamaria.url}
      coordenadorBio="Coordenadora da pós em Fisioterapia em Gerontologia da FEO. Especialista em envelhecimento, fragilidade e reabilitação funcional, com ampla experiência clínica e formação de fisioterapeutas em todo o Brasil."
      ementaSubtitle="Baixe o PDF com a grade completa dos módulos, os professores e o cronograma das aulas da pós em Gerontologia."
      whatsappUrl="https://nimble.li/o9yokpkm"
      whatsappLabel="Falar com o time no WhatsApp"
    />
  );
}
